
























import { Component, Prop, Vue } from "vue-property-decorator";
import { IUnathorizedTV } from "@/@types/admin/add-tv-user";
import { getDate } from "@/services/dateTime/getFullDate";

@Component({ components: {} })
export default class UnathorizedTVList extends Vue {
  @Prop({ type: Array, default: () => [] }) tvs!: Array<IUnathorizedTV>;
  @Prop({ type: String, default: "tv" }) deviceType!: string;

  get labelPrefix(): string {
    return this.deviceType == "tablet"
      ? "Administration.tablet"
      : "Administration.tv";
  }

  get fields(): Array<{ key: string; label: string }> {
    return [
      {
        key: "serialNumber",
        label: String(this.$t(`${this.labelPrefix}.unathorized.serialNumber`)),
      },
      {
        key: "date_ticket",
        label: String(this.$t(`${this.labelPrefix}.unathorized.date_ticket`)),
      },
      { key: "delete_tv", label: "" },
    ];
  }

  get tvList(): Array<IUnathorizedTV> {
    const items: Array<IUnathorizedTV> = [];
    this.tvs.forEach((tv) => {
      const date = getDate(tv.date_ticket);
      items.push({
        _id: tv._id,
        serialNumber: tv.serialNumber,
        date_ticket: date,
      });
    });
    return items;
  }
}
